import api from "./revenuePlannerApi";

const facet = {
  list: (accessToken, body) => api.post("/facet", body, accessToken),
  authorizeEdit: (accessToken, body) => api.post("/facet/authorize-edit", body, accessToken),
};

export default facet;
